module.exports = __webpack_public_path__ + "img/yinbingD.8901a87e.png";